import { createRequestActions, createSingleAction, RequestType } from 'store/utils';
import { IPlacementIdChange } from './models';
import { IAssignment, ISubassignment } from '../../../../../store/entities/configuration/configurationModel';

const SET_OPEN_PLACEMENT_CHANGE = 'employment_management/SET_OPEN_PLACEMENT_CHANGE';
export const setOpenPlacementChange = createSingleAction<
boolean,
typeof SET_OPEN_PLACEMENT_CHANGE
>(
    SET_OPEN_PLACEMENT_CHANGE,
);

const placementAssignmentUpdate = 'employment_management';
export const updatePlacementId = createRequestActions<IPlacementIdChange, IAssignment>(
    RequestType.PATCH,
    'UPDATE_ASSIGNMENT_PLACEMENT',
    placementAssignmentUpdate,
);

export const updateSubassignmentPlacementId = createRequestActions<IPlacementIdChange, ISubassignment>(
    RequestType.PATCH,
    'UPDATE_SUBASSIGNMENT_PLACEMENT',
    placementAssignmentUpdate,
);
